import axios from "axios";
import {
  makeAutoObservable,
  action,
  observable,
  computed,
  runInAction,
} from "mobx";
import { get, eq, some } from "lodash";
import { API_HOST, RequestState, defaultErrorMessage } from "../constants";
import { getSessionCookie, isValidEmail } from "../utils";
import { userStore } from "../stores";

export class EditProfileController {
  editPersonalInfoMessage = "";
  editPersonalInfoMessageRequestState = RequestState.IDLE;

  changePasswordMessage = "";
  changePasswordRequestState = RequestState.IDLE;

  _userStore = userStore;

  constructor() {
    makeAutoObservable(this, {
      editPersonalInfoMessage: observable,
      editPersonalInfoMessageRequestState: observable,
      changePasswordMessage: observable,
      changePasswordMessageRequestState: observable,
      editPersonalInfo: action,
      changePassword: action,
      getEditPersonalInfoMessage: computed,
      getEditPersonalInfoRequestState: computed,
      getChangePasswordMessage: computed,
      getChangePasswordRequestState: computed,
      email: computed,
      gender: computed,
      country: computed,
    });
  }

  async editPersonalInfo({ email, gender, country }, _successCallback) {
    if (some([!email.length, !gender.length, !country.length])) {
      runInAction(() => {
        this.editPersonalInfoMessage = "Please fill all fields.";
      });
      return;
    }

    if (!isValidEmail(email)) {
      runInAction(() => {
        this.editPersonalInfoMessage = "Please enter a valid email address";
      });
      return;
    }

    runInAction(() => {
      this.editPersonalInfoMessageRequestState = RequestState.REQUESTED;
    });

    try {
      const cookie = await getSessionCookie();

      const response = await axios.put(
        `${API_HOST}user/update`,
        {
          email,
          gender,
          country,
        },
        {
          headers: {
            Authorization: cookie,
          },
        }
      );

      if (eq(response.status, 200)) {
        runInAction(() => {
          this.editPersonalInfoMessage = "";
        });

        _successCallback();
      } else {
        runInAction(() => {
          this.editPersonalInfoMessage = get(
            response,
            "data.message",
            defaultErrorMessage
          );
        });
      }
    } catch (error) {
      console.log("Error editing Personal INfo", error);

      runInAction(() => {
        this.editPersonalInfoMessage = get(
          error,
          "response.data.error",
          defaultErrorMessage
        );
      });
    }

    runInAction(() => {
      this.editPersonalInfoMessageRequestState = RequestState.RECEIVED;
    });
  }

  async changePassword({ password, newPassword }, _successCallback) {
    if (some([!password.length, !newPassword.length])) {
      runInAction(() => {
        this.editPersonalInfoMessage = "Please fill all fields.";
      });
      return;
    }

    runInAction(() => {
      this.changePasswordRequestState = RequestState.REQUESTED;
    });

    const cookie = await getSessionCookie();

    try {
      const response = await axios.put(
        `${API_HOST}user/update`,
        {
          password,
          newPassword,
        },
        {
          headers: {
            Authorization: cookie,
          },
        }
      );

      if (eq(response.status, 200)) {
        runInAction(() => {
          this.changePasswordMessage = "";
        });

        _successCallback();
      } else {
        runInAction(() => {
          this.changePasswordMessage = get(
            response,
            "data.message",
            defaultErrorMessage
          );
        });
      }
    } catch (error) {
      console.log("Error changing password", error);

      runInAction(() => {
        this.changePasswordMessage = get(
          error,
          "response.data.error",
          defaultErrorMessage
        );
      });
    }

    runInAction(() => {
      this.changePasswordRequestState = RequestState.RECEIVED;
    });
  }

  get getEditPersonalInfoMessage() {
    return this.editPersonalInfoMessage;
  }

  get getEditPersonalInfoRequestState() {
    return this.editPersonalInfoMessageRequestState;
  }

  get getChangePasswordMessage() {
    return this.changePasswordMessage;
  }

  get getChangePasswordRequestState() {
    return this.changePasswordRequestState;
  }

  get email() {
    return this._userStore.userObj.email;
  }

  get gender() {
    return this._userStore.userObj.gender;
  }

  get country() {
    return this._userStore.userObj.country;
  }
}

export default EditProfileController;
